export enum AppTitle {
  agreementManagement = 'Agreement Management',
  acMaintenance = 'Accessorial Management',
}
